import {Component, OnInit, HostListener} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {isNumeric} from 'rxjs/util/isNumeric';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {CatalogoApiService} from '../../../service/api/catalogo.api';
import {
    ItemConfiguracao,
    ParametroInstalacaoProduto,
    ParametroEntradaInstalacaoAgrupado,
    ItemParametroInstalacaoAgrupado,
    ParametroConteudoInstalacaoProduto,
    InstalacaoProduto,
    ParametroEntradaInstalacaoProduto,
    Cliente
} from '../../../model/catalogo';
import {Router, ActivatedRoute} from '@angular/router';
import {DetalhamentoApiService} from '../../../service/api/detalhamento.api';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {TouchSequence} from '../../../../node_modules/@types/selenium-webdriver';

@Component({
    selector: 'cadastro-instalacao-produto',
    templateUrl: './cadastro-instalacao-produto.component.html',
    styleUrls: ['./cadastro-instalacao-produto.component.css']
})
export class CadastroInstalacaoProdutoComponent {

    modoEdicao: Boolean = false;
    paramsSubscription: Subscription = null;
    itensConfiguracao: Array<ItemConfiguracao> = new Array<ItemConfiguracao>();
    parametrosInstalacao: Array<ParametroEntradaInstalacaoProduto> = new Array<ParametroEntradaInstalacaoProduto>();
    parametrosInstalacaoAgrupados: Array<ParametroEntradaInstalacaoAgrupado> = new Array<ParametroEntradaInstalacaoAgrupado>();
    itensParametroInstalacaoAgrupado1: Array<ItemParametroInstalacaoAgrupado> = new Array<ItemParametroInstalacaoAgrupado>();
    itensParametroInstalacaoAgrupado2: Array<ItemParametroInstalacaoAgrupado> = new Array<ItemParametroInstalacaoAgrupado>();
    itensParametroInstalacaoAgrupado3: Array<ItemParametroInstalacaoAgrupado> = new Array<ItemParametroInstalacaoAgrupado>();


    tipoEdicao: string = '';
    nome = new FormControl('', [Validators.required]);
    descricao = new FormControl('', [Validators.required]);
    nmItemConfiguracao = new FormControl('', [Validators.required]);
    nmItemConfiguracaoEdicao: string = '';

    nmParametroInstalacao = new FormControl('', [Validators.required]);
    conteudoParametroInstalacao = new FormControl('', [Validators.required]);

    vincularIC = new FormControl('', [Validators.required]);

    instalacaoForm: FormGroup = this.formBuilder.group({
        nome: this.nome,
        descricao: this.descricao,
        nmItemConfiguracao: this.nmItemConfiguracao,
    });

    parametrosForm: FormGroup = this.formBuilder.group({
        nmParametroInstalacao: this.nmParametroInstalacao,
        conteudoParametroInstalacao: this.conteudoParametroInstalacao
    });

    ICForm: FormGroup = this.formBuilder.group({
        vincularIC: this.vincularIC,
    });

    constructor(private globalService: GlobalService, private router: Router, public modalService: ModalService, private formBuilder: FormBuilder, private route: ActivatedRoute, private catalogoService: CatalogoApiService, public detalhamentoApiService: DetalhamentoApiService, public pesquisaService: PesquisasFiltroApiService) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13 && this.instalacaoForm.valid) {
                this.salvarInstalacao();
            }
        }
    }

    novaInstalacao: InstalacaoProduto = new InstalacaoProduto();

    conteudoPadrao: Array<String> = new Array<String>();
    nomeSubtipoDado: string = '';

    ngOnInit() {

        this.getItensConfiguracao();
        this.novaInstalacao.codigo = 0;
        this.novaInstalacao.versao = 0;
        this.novaInstalacao.clienteVinculado = new Array<Cliente>();
        this.novaInstalacao.itemConfiguracaoVinculado = new Array<string>();
        this.novaInstalacao.parmInstalacaoProduto = new Array<ParametroInstalacaoProduto>();

        this.paramsSubscription = this.route.params.subscribe(params => {
            if (params['codigo'] != undefined) {
                this.modoEdicao = true;
                this.nmItemConfiguracao.disable();
                this.novaInstalacao.codigo = params['codigo'];
                this.novaInstalacao.versao = params['versao'];
                this.getDadosInstalacao(params['codigo'], params['versao']);
            }
        });

    }

    ngOnDestroy() {
        if (this.paramsSubscription != null) {
            this.paramsSubscription.unsubscribe();
        }
    }

    getItensConfiguracao() {
        let filtros: Array<any> = new Array<any>();
        filtros.push({'filtroItemConfiguracao': {'tipoItemConfiguracao': 1}});
        this.globalService.loading = true;
        this.pesquisaService.filtraItemConfiguracao(filtros)
            .subscribe(
                listaItens => {
                    this.itensConfiguracao = listaItens.sort(function (a, b) {
                        var textA = a.nome;
                        var textB = b.nome;
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    }) as Array<ItemConfiguracao>;
                    this.globalService.loading = false;
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404) {
                        this.itensConfiguracao = new Array<ItemConfiguracao>();
                    }
                }
            );
    }

    getParametrosInstalacao(limpar: boolean) {
        if (limpar) {
            this.novaInstalacao.parmInstalacaoProduto = new Array<ParametroInstalacaoProduto>();
        }
        if (this.nmItemConfiguracao.value != '') {
            this.globalService.loading = true;
            this.detalhamentoApiService.detalhaItemConfiguracao(this.nmItemConfiguracao.value)
                .subscribe(response => {
                        this.parametrosInstalacao = response.itemConfiguracaoProduto.parmEntradaInstalacaoProduto
                            .sort(function (a, b) {
                                var textA = a.nome;
                                var textB = b.nome;
                                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                            });

                        //ajustaListaParametros();

                        this.globalService.loading = false;
                    },
                    erro => {
                        this.globalService.loading = false;
                    });
        } else {
            this.parametrosInstalacao = new Array<ParametroEntradaInstalacaoProduto>();
        }
    }

    ajustaListaParametros() {
        this.parametrosInstalacaoAgrupados = new Array<ParametroEntradaInstalacaoAgrupado>();

        let itensArray: Array<ItemParametroInstalacaoAgrupado> = new Array<ItemParametroInstalacaoAgrupado>();
        let itensSelectExlc: Array<ItemParametroInstalacaoAgrupado> = new Array<ItemParametroInstalacaoAgrupado>();
        let itensTextLivre: Array<ItemParametroInstalacaoAgrupado> = new Array<ItemParametroInstalacaoAgrupado>();

        for (let i in this.parametrosInstalacao) {
            if (this.parametrosInstalacao[i].nomeSubtipoDado == 'array') {
                let item: ItemParametroInstalacaoAgrupado = new ItemParametroInstalacaoAgrupado();
                item.label = this.parametrosInstalacao[i].nome;
                item.valor = this.parametrosInstalacao[i].nome;
                itensArray.push(item);
            } else if (this.parametrosInstalacao[i].nomeSubtipoDado == 'sel_excl') {
                let item: ItemParametroInstalacaoAgrupado = new ItemParametroInstalacaoAgrupado();
                item.label = this.parametrosInstalacao[i].nome;
                item.valor = this.parametrosInstalacao[i].nome;
                itensSelectExlc.push(item);
            } else {
                let item: ItemParametroInstalacaoAgrupado = new ItemParametroInstalacaoAgrupado();
                item.label = this.parametrosInstalacao[i].nome;
                item.valor = this.parametrosInstalacao[i].nome;
                itensTextLivre.push(item);
            }
        }

        let parametrosArray: ParametroEntradaInstalacaoAgrupado = new ParametroEntradaInstalacaoAgrupado();
        parametrosArray.label = 'Tipo:';
        parametrosArray.value = 'Array';

        parametrosArray.items = itensArray;

        let parametrosSeleExcl: ParametroEntradaInstalacaoAgrupado = new ParametroEntradaInstalacaoAgrupado();
        parametrosSeleExcl.label = 'Tipo:';
        parametrosSeleExcl.value = 'Seleção Exclusiva';
        parametrosSeleExcl.items = itensSelectExlc;

        let parametrosTextoLivre: ParametroEntradaInstalacaoAgrupado = new ParametroEntradaInstalacaoAgrupado();
        parametrosTextoLivre.label = 'Tipo:';
        parametrosTextoLivre.value = 'Texto Livre';
        parametrosTextoLivre.items = itensTextLivre;

        if (parametrosArray.items.length > 0) {
            this.parametrosInstalacaoAgrupados.push(parametrosArray);
        }

        if (parametrosSeleExcl.items.length > 0) {
            this.parametrosInstalacaoAgrupados.push(parametrosSeleExcl);
        }

        if (parametrosTextoLivre.items.length > 0) {
            this.parametrosInstalacaoAgrupados.push(parametrosTextoLivre);
        }
    }

    getDadosInstalacao(codigo: number, versao: number) {
        this.detalhamentoApiService.detalhaInstalacaoProduto(codigo, versao)
            .subscribe(
                inst => {
                    this.nmItemConfiguracao.setValue(inst.nomeItemConfiguracaoProduto);
                    this.nmItemConfiguracaoEdicao = inst.nomeItemConfiguracaoProduto;
                    this.nome.setValue(inst.nomeInstalacao);
                    this.descricao.setValue(inst.descricaoInstalacao);
                    this.novaInstalacao.itemConfiguracaoVinculado = inst.itemConfiguracaoVinculado;
                    this.novaInstalacao.clienteVinculado = inst.clienteVinculado;
                    this.novaInstalacao.parmInstalacaoProduto = inst.parmInstalacaoProduto;
                    this.getParametrosInstalacao(false);
                },
                erro => {
                });

    }

    selecionaParametro() {
        for (let i in this.parametrosInstalacao) {
            if (this.parametrosInstalacao[i].nome == this.nmParametroInstalacao.value) {
                if (this.parametrosInstalacao[i].nomeSubtipoDado == 'sel_excl') {
                    this.conteudoPadrao = this.parametrosInstalacao[i].conteudoPadrao;
                    this.nomeSubtipoDado = 'Seleção exclusiva';
                } else if (this.parametrosInstalacao[i].nomeSubtipoDado == 'array') {
                    this.conteudoPadrao = [];
                    this.nomeSubtipoDado = 'Array';
                } else if (this.parametrosInstalacao[i].nomeSubtipoDado == 'password') {
                    this.conteudoPadrao = [];
                    this.nomeSubtipoDado = 'password';
                }else {
                    this.conteudoPadrao = [];
                    this.nomeSubtipoDado = 'Conteúdo Livre';
                }

            }
        }
    }

    addParametro() {


        let existe = false;
        this.novaInstalacao.parmInstalacaoProduto.forEach(parm => {
            if (parm.parmNome == this.parametrosForm.value.nmParametroInstalacao) {
                existe = true;

                if (this.nomeSubtipoDado == 'Seleção exclusiva') {
                    alert('Para o tipo \'Seleção exclusiva\' só é permitido um parâmetro.');
                    return;
                }

                if (this.nomeSubtipoDado == 'Array') {
                    let contParm = new ParametroConteudoInstalacaoProduto;
                    contParm.nrPosicao = 1;
                    contParm.conteudo = this.parametrosForm.value.conteudoParametroInstalacao;

                    parm.parmConteudo.push(contParm);
                } else {
                    existe = false;
                }


            }
        });

        if (!existe) {

            let contParm = new ParametroConteudoInstalacaoProduto;
            contParm.nrPosicao = 1;
            contParm.conteudo = this.parametrosForm.value.conteudoParametroInstalacao;

            let parm = new ParametroInstalacaoProduto;
            parm.parmNome = this.parametrosForm.value.nmParametroInstalacao;

            parm.parmConteudo = new Array<ParametroConteudoInstalacaoProduto>();
            parm.parmConteudo.push(contParm);

            this.novaInstalacao.parmInstalacaoProduto.push(parm);

        }

        this.conteudoPadrao = [];
        this.nomeSubtipoDado = '';

        this.parametrosForm.controls['nmParametroInstalacao'].reset();
        this.parametrosForm.controls['conteudoParametroInstalacao'].reset();
    }

    removerParametro(indice: number) {
        this.novaInstalacao.parmInstalacaoProduto.splice(indice, 1);
    }

    getTipoCliente(tipo: number) {
        switch (tipo) {
            case 1:
                return 'Usuário Impessoal';
            case 2:
                return 'MCI';
            case 3:
                return 'UOR';
        }
    }

    getNomeCliente(cliente: Cliente) {
        switch (cliente.codTipoCliente) {
            case 1:
                return cliente.userAplicacao.nomeUserAplicacao;
            case 2:
                return cliente.mci.nomeCliente == null ? cliente.mci.codMci : cliente.mci.codMci + ' - ' + cliente.mci.nomeCliente;
            case 3:
                return cliente.uor.nomeDependencia == null ? cliente.uor.codUor : cliente.uor.codUor + ' - ' + cliente.uor.nomeDependencia;
            default:
                return 'Não foi possível recuperar o nome do cliente';
        }
    }


    addCliente() {
        let isValor;
        this.modalService.abrirPaginaModal('cliente-modal', {}, {'pesquisar': false},
            'Selecionar Cliente', 'Fechar')
            .subscribe(cliente => {
                if (cliente != null) {

                    if (cliente.mci) {
                        isValor = this.novaInstalacao.clienteVinculado.filter(obj => {
                            return JSON.stringify(obj.mci) === JSON.stringify(cliente.mci);
                        });
                        if (isValor != 0) {

                            alert('Cliente já foi adicionado anteriormente !');
                        } else {
                            this.novaInstalacao.clienteVinculado.push(cliente);
                        }

                    } else if (cliente.uor) {
                        isValor = this.novaInstalacao.clienteVinculado.filter(obj => {
                            return JSON.stringify(obj.uor) === JSON.stringify(cliente.uor);
                        });
                        if (isValor != 0) {

                            alert('Cliente já foi adicionado anteriormente!');
                        } else {
                            this.novaInstalacao.clienteVinculado.push(cliente);
                        }

                    } else if (cliente.userAplicacao) {
                        isValor = this.novaInstalacao.clienteVinculado.filter(obj => {
                            return JSON.stringify(obj.userAplicacao) === JSON.stringify(cliente.userAplicacao);
                        });
                        if (isValor != 0) {

                            alert('Cliente já foi adicionado anteriormente!');
                        } else {
                            this.novaInstalacao.clienteVinculado.push(cliente);
                        }

                    } else if (cliente.userAplicacao) {
                        isValor = this.novaInstalacao.clienteVinculado.filter(obj => {
                            return obj.userAplicacao === cliente.userAplicacao;
                        });
                        if (isValor != 0) {

                            alert('Cliente já foi adicionado anteriormente !');
                        } else {
                            this.novaInstalacao.clienteVinculado.push(cliente);
                        }

                    }

                }
            });
    }


    removerCliente(indice: number) {
        this.novaInstalacao.clienteVinculado.splice(indice, 1);
    }

    addItemConfiguracao() {

        /* TODO - Buscar IC na base de dados */

        if (this.ICForm.value.vincularIC != '') {
            this.novaInstalacao.itemConfiguracaoVinculado.push(this.ICForm.value.vincularIC);
            this.ICForm.controls['vincularIC'].reset();
        }
    }

    removerItemConfiguracao(indice: number) {
        this.novaInstalacao.itemConfiguracaoVinculado.splice(indice, 1);
    }

    salvarInstalacaoModal() {

        var msgInstalacaoProduto: string = 'Por padrão, a alteração é gravada nesta mesma versão da instalação de produto. Se optar por gravar em uma nova versão, os FTAs que atualmente apontam para esta instalação vão manter uso dos parâmetros e definições da versão antiga. Deseja manter a mesma versão vigente ?';

        if (this.modoEdicao) {
            this.modalService.abrirPaginaModal('edicao-artefatos-modal', {}, {
                    'pesquisar': false,
                    'mensagem': msgInstalacaoProduto
                },
                'Confirmação !', 'Fechar')
                .subscribe(res => {
                    if (res.tipoEdicao) {
                        this.tipoEdicao = 'editar';
                    } else {
                        this.tipoEdicao = 'nova';
                    }
                    this.salvarInstalacao();
                });
        } else {
            this.salvarInstalacao();
        }

    }

    salvarInstalacao() {

        /* TODO - Verificar obrigatoriedade dos parâmetros */

        this.globalService.loading = true;


        this.novaInstalacao.nomeInstalacao = this.instalacaoForm.value.nome;
        this.novaInstalacao.descricaoInstalacao = this.instalacaoForm.value.descricao;
        this.novaInstalacao.nomeItemConfiguracaoProduto = this.instalacaoForm.value.nmItemConfiguracao;

        if (this.modoEdicao) {
            this.novaInstalacao.nomeItemConfiguracaoProduto = this.nmItemConfiguracaoEdicao;
        }

        if (this.modoEdicao && this.tipoEdicao == 'nova') {
            this.novaInstalacao.versao = 0;
        }

        this.catalogoService.criaEditaInstalacaoProduto(this.novaInstalacao.codigo, this.novaInstalacao.versao, this.novaInstalacao)
            .subscribe(
                resposta => {
                    this.globalService.loading = false;
                    if (this.tipoEdicao == 'editar') {
                        this.modalService.exibirMensagem('Instalação de Produto', 'Instalação de Produto atualizada com sucesso!', 'Fechar');
                    } else {
                        this.modalService.exibirMensagem('Instalação de Produto', 'Instalação de Produto cadastrada com sucesso!', 'Fechar');
                    }
                    this.voltar();
                },
                erro => {
                    if (erro.status == 400) {
                        this.modalService.exibirMensagem('Instalação de Produto', 'Erro ao cadastrar instalação de produto.<br />Verifique se os campos foram preenchidos corretamente.', 'Fechar');
                    } else if (erro.status == 401) {
                        this.modalService.exibirMensagem('Instalação de Produto', 'Erro ao cadastrar instalação de produto.<br />Token de autenticação fora do formato esperado, inválido ou expirado.', 'Fechar');
                    } else if (erro.status == 403) {
                        this.modalService.exibirMensagem('Instalação de Produto', 'Erro ao cadastrar instalação de produto.<br />Usuário não possui permissão para efetuar essa operação.', 'Fechar');
                    } else if (erro.status == 409) {
                        this.modalService.exibirMensagem('Instalação de Produto', 'Erro ao cadastrar instalação de produto.<br />Código/Versão incorretos.', 'Fechar');
                    } else {
                        this.modalService.exibirMensagem('Instalação de Produto', `Erro ao cadastrar instalação de produto.<br />${erro.error.mensagem}.`, 'Fechar');
                    }
                    this.globalService.loading = false;
                }
            );

        /*
        for(let i=0;i < this.arrayParametroEntradaInstalacaoProduto.length;i++) {
            if(this.conteudoForm.controls["conteudos"].get(this.arrayParametroEntradaInstalacaoProduto[i].nome).value  != "") {

                if (this.arrayParametroEntradaInstalacaoProduto[i].nomeTipoDado == "integer" && !isNumeric(this.conteudoForm.controls["conteudos"].get(this.arrayParametroEntradaInstalacaoProduto[i].nome).value)) {
                    this.modalService.exibirMensagem("Erro", "O parâmetro '"+this.arrayParametroEntradaInstalacaoProduto[i].nome+"' deve ser do tipo numérico!", "Fechar");
                    return false;
                }

                this.parmsInstalacao[i] = new ParametroInstalacaoProduto();
                this.parmsInstalacao[i].parmNome = this.arrayParametroEntradaInstalacaoProduto[i].nome.toString();
                this.parmsInstalacao[i].parmConteudo = new Array<ParametroConteudoInstalacaoProduto>();
                this.parmsInstalacao[i].parmConteudo[0] = new ParametroConteudoInstalacaoProduto();
                this.parmsInstalacao[i].parmConteudo[0].nrPosicao = i+1;
                this.parmsInstalacao[i].parmConteudo[0].conteudo = this.conteudoForm.controls["conteudos"].get(this.arrayParametroEntradaInstalacaoProduto[i].nome).value;
            } else {
                if(this.arrayParametroEntradaInstalacaoProduto[i].obrigatorio) {
                    this.modalService.exibirMensagem("Erro", "O parâmetro '"+this.arrayParametroEntradaInstalacaoProduto[i].nome+"' é obrigatório, informe o conteúdo!", "Fechar");
                    return false;
                }
            }
        }
        */

    }

    voltar() {
        this.router.navigate(['/artefato-instalacao-produto']);
    }


}




// WEBPACK FOOTER //
// ./src/app/artefato/cadastro-instalacao-produto/cadastro-instalacao-produto.component.ts